import { APIRoute } from '@/modules/utils'
import { User } from '@/dataV3/User/User'
import { Petsitter } from '@/dataV3/PetSitter/Petsitter'

export const Route: APIRoute = {
  method: 'GET',
  path: '/members/account',
}

export type Response = User | Petsitter
